<template>
  <b-dropdown
    class="dropdown-language-group"
    right
    size="sm"
    toggle-class="mono text-uppercase dropdown-toggle-group"
    data-cy="app-settings-interface-lang-ddn">
    <template #button-content>
      <i v-if="props.showIcon" class="mdp-Globe"></i>
      <span class="button-content">{{ displayLanguageText }}</span>
    </template>
    <b-dropdown-item
      :active="localeElem.code == unref(locale)"
      v-for="localeElem in locales"
      :key="localeElem.code"
      @click="handleLocaleSwitch(localeElem.code)">
      {{ localeElem.name }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script setup lang="ts">
import { UserSettings } from "@medapro-types/common/rootstate";
import getBrowserLocale from "@util/i18n/get-browser-locale";
import { getSupportedLocales } from "@util/i18n/supported-locales";
import { computed, onMounted, reactive, watch, unref } from "vue";
import { useI18n } from "vue-i18n";
import { useActions, useState } from "vuex-composition-helpers";

const props = defineProps<{ showIcon?: boolean }>();

//#region General
const { locale } = useI18n({ useScope: "global" });
//#endregion

//#region Store
const { userSettings } = useState(["userSettings"]);
const { saveUserSettings } = useActions(["saveUserSettings"]);
//#endregion

//#region ViewModel
type ViewModel = { settings: Pick<UserSettings, "CurrentLocale"> };
const vm = reactive<ViewModel>({ settings: { CurrentLocale: getBrowserLocale() ?? "en" } });
//#endregion

const handleLocaleSwitch = (localeCode: string) => {
  vm.settings.CurrentLocale = localeCode;
  locale.value = localeCode;
};

const locales = computed(() => {
  return getSupportedLocales();
});
const displayLanguageText = computed(() => {
  const displayName = locales.value.find((x) => x.code == locale.value)?.name ?? "";
  return displayName;
});

watch(
  () => vm.settings,
  (nv) => {
    saveUserSettings(nv);
  },
  { deep: true }
);
watch(
  () => userSettings.value,
  (nv) => {
    if (!nv) return;
    Object.assign(vm.settings, {
      CurrentLocale: nv.CurrentLocale
    });
  },
  { immediate: true, deep: true }
);

onMounted(() => {
  locale.value = vm.settings.CurrentLocale;
});
</script>
